export default function getRelativeComplementOfComposeRecipients(recipients, message) {
    var messageRecipients = getUniqueEmailAddressesFromMessage(message);
    var composeRecipients = getUniqueEmailAddressesFromComposeRecipients(recipients);
    return relativeComplementOfArrays(composeRecipients, messageRecipients);
}
function getUniqueEmailAddressesFromComposeRecipients(recipients) {
    var emailAddresses = [];
    recipients.toRecipients.forEach(function (recipient) {
        return updateRecipientsList(emailAddresses, recipient.persona.EmailAddress.EmailAddress);
    });
    recipients.ccRecipients.forEach(function (recipient) {
        return updateRecipientsList(emailAddresses, recipient.persona.EmailAddress.EmailAddress);
    });
    recipients.bccRecipients.forEach(function (recipient) {
        return updateRecipientsList(emailAddresses, recipient.persona.EmailAddress.EmailAddress);
    });
    return emailAddresses;
}
function getUniqueEmailAddressesFromMessage(message) {
    var emailAddresses = [];
    if (message.ToRecipients) {
        message.ToRecipients.forEach(function (recipient) {
            return updateRecipientsList(emailAddresses, recipient.EmailAddress);
        });
    }
    if (message.CcRecipients) {
        message.CcRecipients.forEach(function (recipient) {
            return updateRecipientsList(emailAddresses, recipient.EmailAddress);
        });
    }
    if (message.BccRecipients) {
        message.BccRecipients.forEach(function (recipient) {
            return updateRecipientsList(emailAddresses, recipient.EmailAddress);
        });
    }
    if (message.From) {
        updateRecipientsList(emailAddresses, message.From.Mailbox.EmailAddress);
    }
    return emailAddresses;
}
function updateRecipientsList(emailAddresses, emailAddress) {
    if (!emailAddresses.includes(emailAddress)) {
        emailAddresses.push(emailAddress);
    }
}
function relativeComplementOfArrays(arr1, arr2) {
    var result = arr1.filter(function (item) { return arr2.indexOf(item) === -1; });
    // Removes the duplicates
    result = result.filter(function (item, index, arr) { return arr.indexOf(item) === index; });
    return result;
}
//# sourceMappingURL=getRelativeComplementOfComposeRecipients.js.map